import { MESSAGE_SENDER } from "components/ChatWidget/constants";
import { useEffect, useRef } from "react";
import { format } from 'date-fns';
import { CustomCompMessage, GlobalState, Link, MessageTypes } from "store/types";
import { useSelector } from "react-redux";

const MessageItem = ({ message, profileAvatar, profileClientAvatar, showTimeStamp }) => {
    const messageRef = useRef();
    const { messages, typing, showChat, badgeCount } = useSelector((state: GlobalState) => ({
        messages: state.messages.messages,
        badgeCount: state.messages.badgeCount,
        typing: state.behavior.messageLoader,
        showChat: state.behavior.showChat
    }));


    useEffect(() => {
        const scrollableContainer = document.querySelector(".rcw-messages-container")
        const clientMessages = messages.filter(x => x.sender === MESSAGE_SENDER.CLIENT);
        const clientMessagesLength = localStorage.getItem('@clientMessagesLength') ?? '0';
        const messagesLength = localStorage.getItem('@messagesLength') ?? '0';
        if (clientMessages.length > parseInt(clientMessagesLength) || messages.length >= parseInt(messagesLength)) {
            if (clientMessages.length > 0) {
                const lastMessageId = clientMessages[clientMessages.length - 1]?.customId;
                if (isClient(message.sender) && message.customId === lastMessageId) {
                    localStorage.setItem('@clientMessagesLength', clientMessages.length.toString())
                    localStorage.setItem('@messagesLength', messages.length.toString())
                    if (messageRef.current) {
                        // @ts-ignore
                        const targetPosition = messageRef.current.offsetTop - scrollableContainer.offsetTop;
                        scrollableContainer.scrollTo({
                            top: targetPosition,
                            behavior: 'smooth' // Can be 'auto' for instant scrolling
                        });

                        // @ts-ignore
                        // messageRef.current.scrollIntoView({
                        //     behavior: 'smooth', // You can also use 'auto' for instant scrolling
                        //     block: 'start',     // Scroll so the element is at the top of the widget
                        //     inline: 'nearest'   // Keep it within the current horizontal viewport
                        // });
                    }
                }
            }
        }

    }, [message, messages, showChat, badgeCount])

    const getComponentToRender = (message: MessageTypes | Link | CustomCompMessage) => {
        const ComponentToRender = message.component;
        if (message.type === 'component') {
            return <ComponentToRender {...message.props} />;
        }
        return <ComponentToRender message={message} showTimeStamp={showTimeStamp} />;
    };

    const isClient = (sender) => sender === MESSAGE_SENDER.CLIENT;

    return (
        <div
            className={`rcw-message ${isClient(message.sender) ? 'rcw-message-client' : ''}`}
            key={`${format(message.timestamp, 'hh:mm')}`}
            ref={messageRef}>
            {((profileAvatar && !isClient(message.sender)) ||
                (profileClientAvatar && isClient(message.sender))) &&
                message.showAvatar && (
                    <img
                        src={isClient(message.sender) ? profileClientAvatar : profileAvatar}
                        className={`rcw-avatar ${isClient(message.sender) ? 'rcw-avatar-client' : ''}`}
                        alt="profile"
                    />
                )}
            {getComponentToRender(message)}
        </div>
    )
}


export default MessageItem;